import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core'
import { ButtonModule } from 'primeng/button'

@Component({
   selector: 'footerbar',
   templateUrl: './footerbar.component.html',
   styleUrls: ['./footerbar.component.scss'],
   changeDetection: ChangeDetectionStrategy.OnPush,
   standalone: true,
   imports: [ButtonModule]
})
export class FooterbarComponent {
   constructor(private cdR: ChangeDetectorRef) {}

   currentYear = new Date().getFullYear()

   ngAfterViewInit(): void {
      this.cdR.detach()
   }

   goToPrivacy() {
      window.open('https://www.pnoinnovation.com/privacy-statement/')
   }

   goToDiscalimer() {
      window.open('https://www.pnoinnovation.com/disclaimer/')
   }

   goToCookiePolicy() {
      window.open('https://www.pnoinnovation.com/cookie-policy/')
   }

   goToTermsAndCondition() {
      window.open('https://www.pnoinnovation.com/terms-and-conditions/')
   }
}
